function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function initDetailsSummaries(root) {
  root.querySelectorAll('[id^="Details-"] summary').forEach(initDetailsSummary);
}

function initDetailsSummary(summary) {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
}

initDetailsSummaries(document);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.input.addEventListener("input", this.onInputInput.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.correctInputValue();
    this.validateQtyRules();
  }

  onInputInput(event) {
    this.correctInputValue();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  correctInputValue() {
    let value = parseInt(this.input.value, 10);
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;

    if (isNaN(value)) {
      value = min;
    } else if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }

    this.input.value = value;
  }

  validateQtyRules() {
    const value = parseInt(this.input.value, 10);
    if (this.input.min) {
      const min = parseInt(this.input.min, 10);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max, 10);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector("input");
//     this.changeEvent = new Event("change", { bubbles: true });
//     this.input.addEventListener("change", this.onInputChange.bind(this));
//     this.querySelectorAll("button").forEach((button) =>
//       button.addEventListener("click", this.onButtonClick.bind(this))
//     );
//   }

//   quantityUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.validateQtyRules();
//     this.quantityUpdateUnsubscriber = subscribe(
//       PUB_SUB_EVENTS.quantityUpdate,
//       this.validateQtyRules.bind(this)
//     );
//   }

//   disconnectedCallback() {
//     if (this.quantityUpdateUnsubscriber) {
//       this.quantityUpdateUnsubscriber();
//     }
//   }

//   onInputChange(event) {
//     this.validateQtyRules();
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value)
//       this.input.dispatchEvent(this.changeEvent);
//   }

//   validateQtyRules() {
//     const value = parseInt(this.input.value);
//     if (this.input.min) {
//       const min = parseInt(this.input.min);
//       const buttonMinus = this.querySelector(".quantity__button[name='minus']");
//       buttonMinus.classList.toggle("disabled", value <= min);
//     }
//     if (this.input.max) {
//       const max = parseInt(this.input.max);
//       const buttonPlus = this.querySelector(".quantity__button[name='plus']");
//       buttonPlus.classList.toggle("disabled", value >= max);
//     }
//   }
// }

// customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Cart notification

document.addEventListener('DOMContentLoaded', function() {
  const cartNotificationElement = document.getElementById('cart-notification');
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  const cartOverlay = document.querySelector('.popup-cart-notification__wrapper-overlay');
  const emptyCartContainer = document.querySelector('.popup-cart-notification--empty');
  const noEmptyCartContainer = document.querySelector('.popup-cart-notification__wrapper');

  if (cartNotificationElement) {
    const handleAddToCartButton = (event) => {
      event.preventDefault();
      const button = event.target.closest('.add-to-cart-button');
      if (button.getAttribute('aria-disabled') === 'true') return;
      const form = event.target.closest('form');
      const formData = new FormData(form);
      const productForm = form.closest('product-form');
      const successMessage = productForm ? productForm.querySelector('.main-success-message') : null;
      const productArtnr = button.getAttribute('data-product-artnr');

      if (productArtnr) formData.append('properties[product_king_artnr]', productArtnr);

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      if (cartOverlay) cartOverlay.classList.add('load');
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if (successMessage) {
          successMessage.classList.add('active');
          setTimeout(() => {
            successMessage.classList.remove('active');
          }, 1000); 
        }
        updateCartNotification(false);
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
        if (cartOverlay) cartOverlay.classList.remove('load');
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    };

    const updateCartBadge = (cart) => {
      let cartCountContainer = document.querySelector('.custom-cart-count');
      if (!cartCountContainer) {
        cartCountContainer = document.createElement('div');
        cartCountContainer.className = 'custom-cart-count';
        cartIconBubble.appendChild(cartCountContainer);
      }

      let cartCountElement = cartCountContainer.querySelector('span[aria-hidden="true"]');
      if (!cartCountElement) {
        cartCountElement = document.createElement('span');
        cartCountElement.setAttribute('aria-hidden', 'true');
        cartCountContainer.appendChild(cartCountElement);
      }

      cartCountElement.innerText = cart.item_count;

      if (cart.item_count === 0) {
        if (emptyCartContainer) emptyCartContainer.style.display = 'block';
        if (noEmptyCartContainer) noEmptyCartContainer.style.display = 'none';
        cartCountContainer.style.display = 'none';
      } else {
        if (emptyCartContainer) emptyCartContainer.style.display = 'none';
        if (noEmptyCartContainer) noEmptyCartContainer.style.display = 'block';
        cartCountContainer.style.display = 'block';
      }
    };

    // Product tags (for ReducedVatRate) are not part of /cart.js, so they are
    // fetched per product: the subtotal shows both excl. and incl. VAT.
    const productRateClasses = {};
    const lineVatRates = (cart) => {
      const vat = window.Vat;
      if (!vat) {
        return Promise.resolve(cart.items.map(() => 0));
      }
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return Promise.all(cart.items.map((item) => {
        if (item.taxable === false) return 0;
        if (!productRateClasses[item.handle]) {
          productRateClasses[item.handle] = fetch(`${root}products/${encodeURIComponent(item.handle)}.js`)
            .then((response) => (response.ok ? response.json() : {}))
            .then((product) => vat.rateClass({ tags: product.tags }))
            .catch(() => 'standard');
        }
        return productRateClasses[item.handle].then((className) => vat.rateBp(className));
      }));
    };

    let renderedCart = null;
    const renderCartNotification = (cart, rates) => {
      const cartItemsContainer = document.getElementById('cart-items');
      const cartTotalContainer = document.getElementById('cart-total');
      const vat = window.Vat;
      if (!cartItemsContainer || !cartTotalContainer || !vat) {
        updateCartBadge(cart);
        return;
      }
      renderedCart = { cart, rates };

      const lines = cart.items.map((item, index) => {
        const b2bUnitPrice = bssB2BUnitPrice(item.key, item.variant_id);
        return {
          amount: b2bUnitPrice === null ? item.final_line_price : b2bUnitPrice * item.quantity,
          shopifyAmount: item.final_line_price,
          bp: rates[index],
        };
      });

      cartItemsContainer.innerHTML = '';
      cart.items.forEach((item, index) => {
        const lineIncl = vat.split(lines[index].amount, lines[index].bp).incl;
        const productArtnr = item.properties && item.properties.product_king_artnr ? item.properties.product_king_artnr : item.sku;
        const url = escapeHtml(item.url);
        const title = escapeHtml(item.title);
        const listItem = document.createElement('li');
        listItem.innerHTML = `
          <a href="${url}" class="cart-notification-image-wrapper">
            <img src="${escapeHtml(item.image)}" alt="${title}" width="60" height="60">
          </a>
          <div class="cart-notification-info">
            <a href="${url}" class="cart-notification-item-title">${title}</a>
            <div class="cart-notification-info-bottom">
              <span>${escapeHtml(productArtnr)}</span> 
              <span>${escapeHtml(item.quantity)} piece(s)</span>
            </div>
          </div>
          <div class="cart-notification-price">
            <button class="remove-item-button" data-variant-id="${escapeHtml(item.id)}">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#1C1C1C"/>
              </svg>
            </button>
            <span class="cart-notification-price-text">${vat.formatMoney(lineIncl)}</span>
          </div>
        `;
        cartItemsContainer.appendChild(listItem);
      });

      const labels = vat.config().labels || {};
      cartTotalContainer.innerHTML = `<div class="cart-notification-total"><span>${labels.subtotal}:</span> <div class="cart-vat-prices">${cartVatPricesHtml(vat.cartTotals(lines, cart.total_price))}</div></div>`;
      updateCartBadge(cart);
    };

    const updateCartNotification = (showLoading = true) => {
      if (showLoading && cartOverlay) cartOverlay.classList.add('load');
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => lineVatRates(cart).then(rates => renderCartNotification(cart, rates)))
      .finally(() => {
        if (showLoading && cartOverlay) cartOverlay.classList.remove('load');
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
    };

    document.addEventListener('theme:bss-cart-prices', () => {
      if (renderedCart) renderCartNotification(renderedCart.cart, renderedCart.rates);
    });

    const openCartButton = document.querySelector('.header__icon--cart-link');
    const closeCartNotificationButtons = document.querySelectorAll('.close-cart-notification');

    openCartButton.addEventListener('click', () => {
      if (cartNotificationElement.classList.contains("active")) {
        cartNotificationElement.classList.remove("active");
      } else {
        updateCartNotification();
        cartNotificationElement.classList.add("active");
      }
    });

    closeCartNotificationButtons.forEach(button => {
      button.addEventListener('click', () => {
        cartNotificationElement.classList.remove("active");
      });
    });

    document.addEventListener('click', (event) => {
      if (!cartNotificationElement.contains(event.target) && !openCartButton.contains(event.target)) {
        cartNotificationElement.classList.remove("active");
      }

      if (event.target.closest('.remove-item-button')) {
        const button = event.target.closest('.remove-item-button');
        const variantId = button.dataset.variantId;
        if (cartOverlay) cartOverlay.classList.add('load');
        removeItemFromCart(variantId);
      }
    });

    const removeItemFromCart = (variantId) => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0,
        }),
      })
      .then(response => response.json())
      .then(data => {
        updateCartNotification();
      })
      .finally(() => {
        if (cartOverlay) cartOverlay.classList.remove('load');
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    };

    updateCartNotification(false);

    const addCartListeners = () => {
      document.querySelectorAll('.add-to-cart-button').forEach(button => {
        button.removeEventListener('click', handleAddToCartButton); 
        button.addEventListener('click', handleAddToCartButton);
      });
    };

    addCartListeners();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          addCartListeners();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});

/**
 * Unit price in cents that BSS B2B charges for a cart line, on Shopify's price
 * basis, or null when no B2B price applies. BSS rounds the unit price to the
 * cent and its checkout charges unit x quantity. variantId covers a line that
 * BSS has not loaded yet because it was just added.
 */
function bssB2BUnitPrice(lineKey, variantId) {
  const bss = window.BSS_B2B;
  const storage = bss && bss.storage;
  const getModifyPrice = bss && bss.utils && bss.utils.getModifyPrice;
  if (!storage || typeof getModifyPrice !== 'function') return null;
  let entry = storage.cartStorage && storage.cartStorage.get(lineKey);
  if (!entry && variantId && storage.variantStorage) entry = storage.variantStorage.get(variantId);
  if (!entry) return null;
  const price = getModifyPrice(entry, entry.bssB2bShowPriceKey);
  return typeof price === 'number' && isFinite(price) ? Math.round(price) : null;
}

function escapeHtml(value) {
  return String(value === null || value === undefined ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function cartVatPricesHtml(totals) {
  const vat = window.Vat;
  const labels = vat.config().labels || {};
  let html = '';
  if (totals.excl !== null) html += `<p>${vat.formatMoney(totals.excl)} ${labels.excl}</p>`;
  if (totals.incl !== null) html += `<p>${vat.formatMoney(totals.incl)} ${labels.incl}</p>`;
  if (totals.excl === null || totals.incl === null) html += `<p class="caption-large">${labels.vatAtCheckout}</p>`;
  return html;
}

/* ---------------------------------------------------------------------------
   BSS B2B custom pricing — re-render discounted prices in the theme's
   dual excl/incl BTW layout instead of BSS's default flat markup.

   BSS writes `<s-span> <span>` into elements carrying [bss-b2b-product-price].
   We hook BSS's filter pipeline (window.bssB2BHooks) to schedule a pass that
   rebuilds those elements using the theme's own price classes. The product's
   VAT rate (basis points, delivery country) and labels are stamped by Liquid as
   data attributes (see price.liquid / price-with-vat.liquid); BSS amounts are on
   Shopify's price basis and window.Vat (assets/vat.js) splits them.
--------------------------------------------------------------------------- */
(function () {
  var hooks = (window.bssB2BHooks = window.bssB2BHooks || {});
  hooks.filters = hooks.filters || {};
  hooks.actions = hooks.actions || {};

  var scheduled = false;
  function schedulePass() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      try {
        restyleAll();
      } catch (e) {
        /* keep BSS defaults on any failure */
      }
    });
  }

  function chainFilter(name) {
    var prev = hooks.filters[name];
    hooks.filters[name] = function (value, ctx) {
      if (typeof prev === 'function') value = prev(value, ctx);
      schedulePass();
      return value;
    };
  }
  chainFilter('custom:CpUtilsConcrete/cp_pl_show_price');
  chainFilter('custom:product_page/cp_pl_show_price');

  // BSS's checkout rounds a percentage discount in euros to the cent, its
  // storefront rounds the discounted price: a half-cent discount then shows a
  // cent more than checkout charges. This mirrors the checkout; it matches all
  // 413 production order lines with a per-unit percentage discount.
  var previousRoundFilter = hooks.filters['custom:cpPrice/round'];
  hooks.filters['custom:cpPrice/round'] = function (value, ctx) {
    if (typeof previousRoundFilter === 'function') value = previousRoundFilter(value, ctx);
    var discountTypes = window.BSS_B2B && window.BSS_B2B.enum && window.BSS_B2B.enum.ODiscountType;
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    if (!ctx || !discountTypes || ctx.type !== discountTypes.DECREASE_PERCENTAGE || rate !== 1) return value;
    var discountEuros = parseFloat((((ctx.price / 100) * Number(ctx.value)) / 100).toFixed(2));
    return ctx.price - Math.round(discountEuros * 100);
  };

  var cartPassScheduled = false;
  function scheduleCartPass() {
    if (cartPassScheduled) return;
    cartPassScheduled = true;
    requestAnimationFrame(function () {
      cartPassScheduled = false;
      document.dispatchEvent(new CustomEvent('theme:bss-cart-prices'));
      restyleCart();
    });
  }

  // BSS runs these actions right after it writes its prices into the cart: per
  // line (custom pricing, quantity breaks) and for the subtotal.
  ['custom:cart/showPrice', 'custom:qbCart/showPrice', 'custom:cart/showSubtotalPrice'].forEach(function (name) {
    var previousAction = hooks.actions[name];
    hooks.actions[name] = function (payload) {
      if (typeof previousAction === 'function') previousAction(payload);
      scheduleCartPass();
    };
  });

  // Safety net in case BSS finished before this script evaluated.
  function runPasses() {
    schedulePass();
    scheduleCartPass();
  }
  if (document.readyState === 'complete') runPasses();
  else window.addEventListener('load', runPasses);

  function restyleCart() {
    var subtotal = document.querySelector('[data-cart-total-price]');
    if (!subtotal || !window.Vat) return;
    var lines = [];
    var rows = document.querySelectorAll('.cart-item[data-cart-item-key][data-vat-bp]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var bp = parseInt(row.getAttribute('data-vat-bp'), 10) || 0;
      var quantity = parseInt(row.getAttribute('data-quantity'), 10) || 0;
      var shopifyAmount = parseInt(row.getAttribute('data-final-line-price'), 10) || 0;
      var unitPrice = bssB2BUnitPrice(row.getAttribute('data-cart-item-key'), null);
      if (unitPrice !== null) restyleCartRow(row, unitPrice, quantity, bp);
      lines.push({
        amount: unitPrice === null ? shopifyAmount : unitPrice * quantity,
        shopifyAmount: shopifyAmount,
        bp: bp,
      });
    }
    var cartTotalPrice = parseInt(subtotal.getAttribute('data-cart-total-price'), 10) || 0;
    subtotal.innerHTML = cartVatPricesHtml(window.Vat.cartTotals(lines, cartTotalPrice));
  }

  function restyleCartRow(row, unitPrice, quantity, bp) {
    var vat = window.Vat;
    var originalPrice = parseInt(row.getAttribute('data-original-price'), 10) || 0;
    var unitIncl = vat.formatMoney(vat.split(unitPrice, bp).incl);
    var originalIncl = vat.formatMoney(vat.split(originalPrice, bp).incl);
    var unitHtml =
      unitPrice < originalPrice ? '<s class="cart-item__old-price">' + originalIncl + '</s> ' + unitIncl : unitIncl;
    var finalUnit = row.querySelector('[bss-b2b-item-final-price]');
    var unitEls = row.querySelectorAll('[bss-b2b-item-original-price]');
    for (var i = 0; i < unitEls.length; i++) unitEls[i].innerHTML = finalUnit ? originalIncl : unitHtml;
    if (finalUnit) finalUnit.innerHTML = unitIncl;
    var lineWrapper = row.querySelector('.cart-item__price-wrapper');
    if (lineWrapper) {
      lineWrapper.innerHTML =
        '<span class="price price--end">' + vat.formatMoney(vat.split(unitPrice * quantity, bp).incl) + '</span>';
    }
  }

  function parseAmountCents(text) {
    var t = (text || '').replace(/\s/g, '');
    var m = t.match(/(\d[\d.,]*)/);
    if (!m) return null;
    var num = m[1];
    var dec = '00';
    var sep = num.match(/[.,](\d{1,2})$/);
    var intPart = num;
    if (sep) {
      dec = (sep[1] + '0').slice(0, 2);
      intPart = num.slice(0, num.length - sep[0].length);
    }
    intPart = intPart.replace(/[.,]/g, '');
    var cents = parseInt(intPart, 10) * 100 + parseInt(dec, 10);
    return isNaN(cents) ? null : cents;
  }

  function formatMoneyCents(cents, sampleText) {
    if (window.BSS_B2B && typeof window.BSS_B2B.formatMoney === 'function') {
      try {
        return window.BSS_B2B.formatMoney(cents);
      } catch (e) {
        /* fall through to sample-based formatting */
      }
    }
    var sample = (sampleText || '').trim();
    var m = sample.match(/^(.*?)(\d[\d.,\s]*\d|\d)(.*)$/);
    var prefix = m ? m[1] : '\u20ac';
    var suffix = m ? m[3] : '';
    var decSep = /,\d{1,2}$/.test((m ? m[2] : '').trim()) ? ',' : '.';
    var thouSep = decSep === ',' ? '.' : ',';
    var whole = Math.floor(cents / 100);
    var rest = ('0' + (cents % 100)).slice(-2);
    var intStr = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return prefix + intStr + decSep + rest + suffix;
  }

  function getPricesFromElement(el, struckEl, currentEl, holder) {
    // Primary: BSS variant storage (exact cents). Fallback: parse rendered text.
    // Amounts are on Shopify's price basis (incl. or excl. VAT, see window.__vat).
    var was = null;
    var now = null;
    var variantId = Number(el.getAttribute('bss-b2b-variant-id'));
    var storage =
      window.BSS_B2B && window.BSS_B2B.storage && window.BSS_B2B.storage.variantStorage;
    if (variantId && storage && typeof storage.get === 'function') {
      var v = storage.get(variantId);
      if (v && v.bssB2BPriceAfterCP != null) {
        was = Math.round(v.price);
        now = Math.round(v.bssB2BPriceAfterCP);
        // Guard against a stale variant attribute: rendered text wins on mismatch.
        var renderedNow = parseAmountCents(currentEl.textContent);
        if (renderedNow !== null && Math.abs(renderedNow - now) > 1) {
          was = null;
          now = null;
        }
      }
    }
    if (now === null) {
      now = parseAmountCents(currentEl.textContent);
      was = struckEl ? parseAmountCents(struckEl.textContent) : null;
    }
    var compareAt = holder ? parseInt(holder.getAttribute('data-compare-at-price'), 10) : NaN;
    if (compareAt > 0 && (was === null || compareAt > was)) was = compareAt;
    return { was: was, now: now };
  }

  function restyleAll() {
    var els = document.querySelectorAll('[bss-b2b-product-price]');
    for (var i = 0; i < els.length; i++) restyle(els[i]);
  }

  function restyle(el) {
    // Only touch elements that currently hold BSS's flat span markup.
    var childSpans = el.querySelectorAll(':scope > span');
    if (!childSpans.length) return;
    var struckEl = null;
    var currentEl = null;
    for (var i = 0; i < childSpans.length; i++) {
      var st = childSpans[i].getAttribute('style') || '';
      if (st.indexOf('line-through') !== -1) struckEl = childSpans[i];
      else if (!currentEl) currentEl = childSpans[i];
    }
    if (!currentEl) return;

    var holder = el.closest('[data-vat-bp]');
    if (!holder || !window.Vat) return;
    var vatBp = parseInt(holder.getAttribute('data-vat-bp'), 10) || 0;
    var exclLabel = holder.getAttribute('data-vat-excl-label') || '';
    var inclLabel = holder.getAttribute('data-vat-incl-label') || '';

    var prices = getPricesFromElement(el, struckEl, currentEl, holder);
    if (prices.now === null) return;

    var sample = currentEl.textContent;
    var now = window.Vat.split(prices.now, vatBp);
    var hasWas = prices.was !== null && prices.was > prices.now;
    var was = hasWas ? window.Vat.split(prices.was, vatBp) : null;
    var inclNowStr = formatMoneyCents(now.incl, sample);
    var exclNowStr = formatMoneyCents(now.excl, sample);
    var inclWasStr = hasWas ? formatMoneyCents(was.incl, sample) : '';
    var exclWasStr = hasWas ? formatMoneyCents(was.excl, sample) : '';

    var inCard = !!el.closest(
      '.card-wrapper, .collection-products__item, .featured-products__item'
    );

    if (el.classList.contains('price') || el.querySelector(':scope > .price')) {
      renderPriceSnippetLayout(el, {
        exclWas: exclWasStr,
        inclWas: inclWasStr,
        exclNow: exclNowStr,
        inclNow: inclNowStr,
        exclLabel: exclLabel,
        inclLabel: inclLabel,
        hasWas: hasWas,
        // Cards get an image-overlay badge instead (addDiscountBadge).
        inlineBadge: hasWas && !inCard ? discountPct(was.incl, now.incl) : 0,
      });
    } else if (el.classList.contains('product-price-with-vat')) {
      renderVatRowsLayout(el, {
        exclWas: exclWasStr,
        inclWas: inclWasStr,
        exclNow: exclNowStr,
        inclNow: inclNowStr,
        exclLabel: exclLabel,
        inclLabel: inclLabel,
        hasWas: hasWas,
      });
    }
    // Other contexts (e.g. volume-pricing "each" spans) keep BSS's default.

    if (hasWas) addDiscountBadge(el, was.incl, now.incl);
  }

  function discountPct(inclWas, inclNow) {
    var pct = Math.round((1 - inclNow / inclWas) * 100);
    return pct >= 1 ? pct : 0;
  }

  function addDiscountBadge(el, inclWas, inclNow) {
    var pct = discountPct(inclWas, inclNow);
    if (!pct) return;
    var label = '-' + pct + '%';

    // Badge is absolutely positioned top-left inside the card's relative
    // image container (all three card systems used by this theme).
    var host = null;
    var card = el.closest('.collection-products__item, .featured-products__item');
    if (card) {
      host =
        card.querySelector(
          '.collection-products__image-wrapper, .featured-products__image-wrapper'
        ) || card;
    } else {
      host = el.closest('.card-wrapper');
    }
    if (!host) return; // not a product card (e.g. product page) - no badge

    var existing = host.querySelector('.bss-discount-badge');
    if (existing) {
      existing.textContent = label;
      return;
    }
    var span = document.createElement('span');
    span.className = 'badge bss-discount-badge';
    span.textContent = label;
    host.appendChild(span);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function renderPriceSnippetLayout(el, p) {
    var target = el.classList.contains('price') ? el : el.querySelector(':scope > .price');
    target.classList.add('price--on-sale');
    var wasHTML = p.hasWas
      ? '<span class="price__was">' +
        '<s class="price-item price-item-without-vat">' + esc(p.exclWas) + '</s>' +
        '<s class="price-item price-item--regular">' + esc(p.inclWas) + '</s>' +
        '</span>'
      : '';
    var badgeHTML = p.inlineBadge
      ? '<span class="badge bss-discount-badge bss-discount-badge--inline">-' +
        p.inlineBadge +
        '%</span>'
      : '';
    target.innerHTML =
      '<div class="price__container"><div class="price__sale">' +
      wasHTML +
      '<span class="price__now">' +
      '<span class="price-item price-item-without-vat"><b>' + esc(p.exclNow) + '</b> ' +
      '<span class="price-vat-label">' + esc(p.exclLabel) + '</span></span>' +
      '<span class="price-item price-item--sale price-item--last"><b>' + esc(p.inclNow) + '</b> ' +
      '<span class="price-vat-label">' + esc(p.inclLabel) + '</span></span>' +
      '</span>' +
      badgeHTML +
      '</div></div>';
  }

  function renderVatRowsLayout(el, p) {
    var wasExcl = p.hasWas ? '<s class="bss-cp-was">' + esc(p.exclWas) + '</s> ' : '';
    var wasIncl = p.hasWas ? '<s class="bss-cp-was">' + esc(p.inclWas) + '</s> ' : '';
    el.innerHTML =
      '<p>' + wasExcl + '<span>' + esc(p.exclNow) + '</span> ' + esc(p.exclLabel) + '</p>' +
      '<p>' + wasIncl + '<span>' + esc(p.inclNow) + '</span> ' + esc(p.inclLabel) + '</p>';
  }
})();
